import { createSvgComponent } from "../../icon/createSvgComponent";
import Target2 from "@core/__generated__/icon/figma/target-2.svg";
export default createSvgComponent(Target2);